import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';
import { urlJoin } from '../../core/helpers/url.helper';
import { CatalogSearchResponse, ReferenceCategoryEnum, ReferenceValue } from './reference.model';
import { map, Observable } from 'rxjs';
import { ReferenceStore } from './reference-store.service';

@Injectable({
  providedIn: 'root'
})
export class ReferenceService {
  private readonly httpClient = inject(HttpClient);
  private readonly appConfig = inject(AppConfig);
  private readonly referenceStore = inject(ReferenceStore);
  private readonly url = urlJoin(this.appConfig.url, 'references');

  fetchAllReferences(): Observable<void> {
    const body = {
      catalogIds: [
        ReferenceCategoryEnum.NATIONALITY,
        ReferenceCategoryEnum.COUNTRY,
        ReferenceCategoryEnum.JURIDIC_FORM,
        ReferenceCategoryEnum.METROPOLITAN_DEPARTMENT,
        ReferenceCategoryEnum.ABROAD_DEPARTMENT,
        ReferenceCategoryEnum.SUB_STATUS,
        ReferenceCategoryEnum.IDENTITY_PIECE_TYPE,
        ReferenceCategoryEnum.HABITATION,
        ReferenceCategoryEnum.CO_HOLDER_TYPE,
        ReferenceCategoryEnum.FAMILY_SITUATION,
        ReferenceCategoryEnum.BANK_TYPE
      ]
    };

    return this.httpClient.post<CatalogSearchResponse>(urlJoin(this.url, 'search'), body).pipe(
      map(response => {
        for (const catalog of response.catalogResponseList) {
          this.referenceStore.storeReferenceValue(catalog);
        }
      })
    );
  }

  fetchProfessionsBySectorKey(sectorKey: string): Observable<ReferenceValue[]> {
    return this.httpClient.get<ReferenceValue[]>(urlJoin(this.url, 'sectors', sectorKey, 'professions'));
  }

  getContractsForProfessionAndEntryDate(sectorKey: string, professionKey: string): Observable<ReferenceValue[]> {
    return this.httpClient.get<ReferenceValue[]>(
      urlJoin(this.url, 'sectors', sectorKey, 'professions', professionKey, 'contracts')
    );
  }
}
